import { createApp } from "vue";
import PipPlayer from "@/components/Streaming/PipPlayer.vue";
import store from "@/store";


class PipService {
    pipWindow = null;
    app = null;
    videoEl = null;
    videoParent = null;
    onClose = null;

    async copyStyles() {
        if (!this.pipWindow)
            return;

        const pipDoc = this.pipWindow.document;

        // style 태그 복사 (dev)
        document.querySelectorAll('style').forEach(style => {
                pipDoc.head.appendChild(style.cloneNode(true));
        });

        // css link 복사 (build)
        document.querySelectorAll('link[rel="stylesheet"]').forEach(link => {
                pipDoc.head.appendChild(link.cloneNode(true));
        });
    }
    async open(videoPlayer) {
        const videoEl = videoPlayer.el();

        if (!videoEl) {
            console.error("PiP video element 없음");
            return;
        }

        this.pipWindow = await window.documentPictureInPicture.requestWindow({
                width: 800,
                height: 600
        });

        this.videoEl = videoEl;
        this.videoParent = videoEl.parentNode;

        /*
            중요:
            build 환경에서는 css가 link로 빠지므로
            DOM 이동 전에 복사
        */
        await this.copyStyles();

        const pipDoc = this.pipWindow.document;
        const videoContainer = pipDoc.createElement("div");
        videoContainer.className = "pip-video";
        videoContainer.style.width = "100%";
        videoContainer.style.height = "100%";
        videoContainer.style.flex = "1";
        videoContainer.style.minHeight = "0";

        pipDoc.body.appendChild(videoContainer);

        // video.js root 이동
        videoContainer.appendChild(videoEl);
        const mountEl = pipDoc.createElement("div");
        mountEl.className = "pip-player";
        pipDoc.body.appendChild(mountEl);

        this.app = createApp(PipPlayer);
        this.app.use(store);
        this.app.mount(mountEl);

        const pipStyle = pipDoc.createElement("style");

        pipStyle.textContent = `
            html,
            body {
                margin:0;
                padding:0;
                width:100%;
                height:100%;
                overflow:hidden;
            }
            body {
                display:flex;
                flex-direction:column;
            }
            .pip-video {
                flex:1 1 auto;
                width:100%;
                height:100%;
                min-height:0;
                overflow:hidden;
            }
            .pip-video .video-js,
            .pip-video .video-js video {
                width:100% !important;
                height:100% !important;
            }
            .pip-player {
                flex:0 0 auto;
            }
        `;

        pipDoc.head.appendChild(pipStyle);

        this.pipWindow.addEventListener("pagehide", async () => {
                await this.close();
                this.onClose?.();
            }
        );
    }
    restoreVideo() {
        if (this.videoEl && this.videoParent) {
            this.videoParent.appendChild(this.videoEl);
        }
    }
    async close() {
        this.restoreVideo();
        this.app?.unmount();
        this.app = null;
        if (this.pipWindow) {
            this.pipWindow.close?.();
        }
        this.pipWindow = null;
    }
}
export default new PipService();